module.exports = __webpack_public_path__ + "static/img/footer_logo.d6c4766.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer_logo.png
// module id = t0Qz
// module chunks = 1